export default {
  computed: {
    shouldShowMobileVersion() {
      return this.isMdMax || this.isTablet;
    },
    mobileLinks() {
      return [
        [
          {
            label: this.translate('Home'),
            link: '/home',
            icon: 'home',
            visible: this.isLoggedIn,
            target: '_self',
          },
          {
            label: this.translate('Log in'),
            icon: 'login',
            action: 'login',
            visible: !this.isLoggedIn,
          },
          {
            label: this.translate('Become a Member'),
            icon: 'account-plus',
            action: 'signin',
            visible: !this.isLoggedIn,
          },
          this.mobileJobMenuItem,
          this.mobileHeadhuntersMenuItem,
          this.resumeMenuItem,
          this.coachingMenuItem,
        ],
        [
          {
            label: this.translate('Customer Reviews'),
            link: `${this.countryBaseUrl}reviews`,
            target: '_self',
            icon: 'like',
            visible: !this.isLoggedIn,
          },
          this.assessmentReportMenuItem,
          {
            label: this.translate('Help'),
            link: this.helpLink,
            icon: 'help-circle',
            target: '_blank',
          },
        ],
        [
          this.countrySelectorMobileItem,
          {
            label: this.translate('My account'),
            link: '/account',
            icon: 'cog',
            visible: this.isLoggedIn,
          },
        ],
        [
          {
            label: this.translate('Log out'),
            icon: 'logout',
            action: 'logout',
            visible: this.isLoggedIn,
          },
        ],
      ].map((section) => section.filter((item) => item.visible !== false));
    },
    mobileJobMenuItem() {
      const link = '/search/jobs';

      return {
        label: this.translate('Jobs'),
        icon: 'magnify',
        options: [
          {
            label: this.translate('New search'),
            link: link + '?view=new-search',
            target: '_self',
          },
          {
            label: this.translate('Bookmarked'),
            link: link + '?view=bookmarked',
            target: '_self',
            visible: !!this.getNumbers('job').bookmarks,
          },
          {
            label: this.translate('Saved searches'),
            link: link + '?view=saved',
            target: '_self',
            visible: !!this.getNumbers('job').savedSearches,
          },
          {
            label: this.translate('Last search'),
            link: link,
            target: '_self',
            visible: this.isLoggedIn,
          },
        ].filter((option) => option.visible !== false),
      };
    },
    mobileHeadhuntersMenuItem() {
      const label = this.translate('Headhunters');
      const icon = 'account';

      if (!this.isLoggedIn) {
        return {
          label,
          icon,
          link: `${this.countryBaseUrl}headhunters`,
          target: '_self',
        };
      }

      return {
        label,
        icon,
        options: [
          {
            label: this.translate('New search'),
            link: {
              name: 'search-headhunter',
              query: {
                view: 'new-search',
              },
            },
          },
          {
            label: this.translate('Bookmarked'),
            link: {
              name: 'search-headhunter',
              query: {
                view: 'bookmarked',
              },
            },
            visible: !!this.getNumbers('headhunter').bookmarks,
          },
          {
            label: this.translate('Last search'),
            link: { name: 'search-headhunter' },
          },
        ].filter((option) => option.visible !== false),
      };
    },
  },
  watch: {
    $route(newValue) {
      if (!this.shouldShowMobileVersion) return;
      if (newValue.name === 'search-jobs-slug' || newValue.name === 'search-headhunter-jobs-slug') {
        this.$refs.header.setMobileMenuActivity(false);
      }
    },
  },
};
